import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PolicySelectorField } from "../PolicySelector";
export const ScanRequestPermission = () => {
    const intl = useIntl();
    const policyOptions = [
        {
            value: ["scan_request_edit" /* PolicyActions.SCAN_REQUEST_EDIT */, "scan_request_create" /* PolicyActions.SCAN_REQUEST_CREATE */],
            label: intl.formatMessage(messages.scanRequestPermissionOptionView),
        },
        {
            value: ["scan_request_create" /* PolicyActions.SCAN_REQUEST_CREATE */],
            label: intl.formatMessage(messages.scanRequestPermissionOptionEdit),
        },
        {
            value: [],
            label: intl.formatMessage(messages.scanRequestPermissionOptionCreate),
        },
        {
            value: ["scan_request_create" /* PolicyActions.SCAN_REQUEST_CREATE */, "scan_request_edit" /* PolicyActions.SCAN_REQUEST_EDIT */, "scan_request_read" /* PolicyActions.SCAN_REQUEST_READ */],
            label: intl.formatMessage(messages.scanRequestPermissionOptionNoAccess),
        },
    ];
    return (React.createElement(PolicySelectorField, { label: intl.formatMessage(messages.scanRequestPermissionLabel), policyOptions: policyOptions, id: "deny.scanRequest" }));
};
export default ScanRequestPermission;
